<div class="hex-cell-wrapper">
  <a #anchor class="hex-link" [href]="url" oncoxntextmenu="return false;"></a>
  <div #hexcell class="hex-cell">
    <div class='outline'><div></div></div>
    <div class='image-wrap'>
      <div>
        <div class='image' [style.background-image]="'url(' + bgImage + ')'"></div>
      </div>
    </div>
    <div class='label'>
      <div><ng-content></ng-content></div>      
    </div>
  </div>
  <svg style="width: 0; height: 0; position: absolute;" aria-hidden="true" focusable="false">
    <defs>
      <clipPath id="roundedPolygon" clipPathUnits="objectBoundingBox">
        <path [attr.d]="hexPathRounded()" />
      </clipPath>
    </defs>
  </svg>
</div>
